import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';

const LEFT_ICON_SIZE = '32px';
const RIGHT_ICON_SIZE = '24px';

export interface IMplCardListItemStyledProps {
	disabled?: boolean;
}

export interface IStyledCardListItemContainerProps
	extends IMplCardListItemStyledProps {
	hasIcon?: boolean;
}

export const StyledCardListItemContainer = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'hasIcon',
})<IStyledCardListItemContainerProps>(({ theme, disabled, hasIcon }) => ({
	width: '100%',
	height: '58px',
	boxSizing: 'border-box',
	border: disabled
		? `0.5px solid ${theme.palette.solutions?.[100]}`
		: `0.5px solid ${theme.palette.solutions?.[600]}`,
	borderRadius: '8px',
	flexDirection: 'row',
	alignItems: 'center',
	paddingLeft: hasIcon ? '8px' : '12px',
	paddingRight: '8px',
	cursor: disabled ? 'not-allowed' : 'pointer',
	backgroundColor: 'transparent',
	opacity: disabled ? 0.4 : 1,
	transition: 'border-color 0.2s ease, opacity 0.2s ease',
	'&:hover': {
		borderColor: disabled
			? theme.palette.solutions?.[100]
			: theme.palette.solutions?.[600],
	},
}));

export const StyledLeftIconWrapper = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'disabled',
})<IMplCardListItemStyledProps>(() => ({
	marginRight: '8px',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	width: LEFT_ICON_SIZE,
	height: LEFT_ICON_SIZE,
}));

export const StyledRightIconWrapper = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'disabled',
})<IMplCardListItemStyledProps>(() => ({
	marginLeft: '4px',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	width: RIGHT_ICON_SIZE,
	height: RIGHT_ICON_SIZE,
}));

export const TRUNCATE_TEXT_SX_PROPS: SxProps = {
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
};
